"use client";

import { ForwardRefExoticComponent, memo, useMemo, forwardRef, RefAttributes } from "react";
import { IEventFeedResponse } from "@finbackoffice/websocket-client";
import { useGetCurrentFeedType } from "hooks";
import { FeedScopeEnum } from "utils/constants";
import ResultsGame from "components/sport/results/ResultsGame";
import classNames from "classnames";
import { LiveCategoriesVariantType } from "../../layouts/categories/LiveCategories";
import LiveTournamentGame, { LiveTournamentGameLayoutEnum } from "./LiveTournamentGame";
import styles from "./live-games-container.module.sass";

interface IProps {
    games: IEventFeedResponse[];
    gameLayout?: LiveTournamentGameLayoutEnum;
    variant?: LiveCategoriesVariantType;
    isTwoColumns: boolean;
}

const LiveGamesContainer: ForwardRefExoticComponent<IProps & RefAttributes<HTMLDivElement>> =
    forwardRef(({ games, gameLayout, isTwoColumns, variant = "default" }, ref) => {
        const feed: FeedScopeEnum = useGetCurrentFeedType();

        const renderContent = useMemo(() => {
            if (feed === FeedScopeEnum.results) {
                return games.map((game) => <ResultsGame key={game.id} game={game} />);
            } else {
                return games.map((game) => (
                    <LiveTournamentGame
                        key={game.id}
                        game={game}
                        layout={gameLayout || LiveTournamentGameLayoutEnum.Default}
                        isTwoColumns={isTwoColumns}
                    />
                ));
            }
        }, [feed, games, gameLayout, isTwoColumns]);

        return (
            <div ref={ref} className={classNames(styles.container, styles[variant])}>
                {renderContent}
            </div>
        );
    });

export default memo(LiveGamesContainer);
